// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const SharePlanDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "shareplandialogcontainer" */ "./SharePlanDialogContainer")).then((bundle)=>{
        return {
            default: bundle.SharePlanDialogContainer
        };
    });
export const LazySharePlanDialogContainer = /*#__PURE__*/ lazy(SharePlanDialogContainerLazyLoader);
